<template>
  <svg
    v-if="!isActive"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66667 16H4L16 4L28 16H25.3333"
      stroke="#99A4B2"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.6665 16V25.3333C6.6665 26.0406 6.94746 26.7189 7.44755 27.219C7.94765 27.719 8.62593 28 9.33317 28H22.6665C23.3737 28 24.052 27.719 24.5521 27.219C25.0522 26.7189 25.3332 26.0406 25.3332 25.3333V16"
      stroke="#99A4B2"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 28.0007V20.0007C12 19.2934 12.281 18.6151 12.781 18.115C13.2811 17.6149 13.9594 17.334 14.6667 17.334H17.3333C18.0406 17.334 18.7189 17.6149 19.219 18.115C19.719 18.6151 20 19.2934 20 20.0007V28.0007"
      stroke="#99A4B2"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <svg
    v-else
    class="block"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.66667 16H4L16 4L28 16H25.3333" fill="#FF6600" />
    <path
      d="M6.66667 16H4L16 4L28 16H25.3333"
      stroke="#FF6600"
      stroke-width="2.20267"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.6665 16V25.3333C6.6665 26.0406 6.94746 26.7189 7.44755 27.219C7.94765 27.719 8.62593 28 9.33317 28H22.6665C23.3737 28 24.052 27.719 24.5521 27.219C25.0522 26.7189 25.3332 26.0406 25.3332 25.3333V16"
      fill="#FF6600"
    />
    <path
      d="M6.6665 16V25.3333C6.6665 26.0406 6.94746 26.7189 7.44755 27.219C7.94765 27.719 8.62593 28 9.33317 28H22.6665C23.3737 28 24.052 27.719 24.5521 27.219C25.0522 26.7189 25.3332 26.0406 25.3332 25.3333V16"
      stroke="#FF6600"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 28.0007V20.0007C12 19.2934 12.281 18.6151 12.781 18.115C13.2811 17.6149 13.9594 17.334 14.6667 17.334H17.3333C18.0406 17.334 18.7189 17.6149 19.2189 18.115C19.719 18.6151 20 19.2934 20 20.0007V28.0007"
      fill="#F0F2F4"
    />
    <path
      d="M12 28.0007V20.0007C12 19.2934 12.281 18.6151 12.781 18.115C13.2811 17.6149 13.9594 17.334 14.6667 17.334H17.3333C18.0406 17.334 18.7189 17.6149 19.2189 18.115C19.719 18.6151 20 19.2934 20 20.0007V28.0007"
      stroke="#FF6600"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'HomeGICIcon',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
